import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import "./ResponsiveNavbar.css";

const navItems = [
  { to: "/", label: "หน้าแรก", end: true },
  { to: "/shop", label: "ร้านค้า" },
  { to: "/hotdeal", label: "โปรโมชั่นเด็ด" },
  { to: "/new-arrivals", label: "สินค้าใหม่" },
  { to: "/promotion-user", label: "โปรโมชั่น" },
  { to: "/about", label: "เกี่ยวกับเรา" },
  { to: "/partner", label: "ศูนย์พาร์ทเนอร์" },
];

const ResponsiveNavbar = () => {
  const { user } = useSelector((state) => ({ ...state }));
  const [open, setOpen] = useState(false);

  const employeeItem =
    user?.role === "employee" ? { to: "/employ-shop", label: "Employee Shop" } : null;

  const allItems = employeeItem ? [...navItems, employeeItem] : navItems;

  return (
    <div className="navbar-wrap">
      {/* ===== Desktop navbar ===== */}
      <nav className="navbar-row">
        {allItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
          >
            {item.label}
          </NavLink>
        ))}
      </nav>

      {/* ===== Mobile toggle ===== */}
      <button
        className="mobile-toggle"
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
        aria-label="เมนู"
      >
        <span className="burger">
          <span /><span /><span />
        </span>
        <span className="mobile-menu-label">เมนู</span>
      </button>

      {/* ===== Mobile drawer ===== */}
      <div className={`mobile-drawer ${open ? "open" : ""}`}>
        {allItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
            onClick={() => setOpen(false)}
          >
            {item.label}
          </NavLink>
        ))}
      </div>
    </div>
  );
};

export default ResponsiveNavbar;